/**
 * @generated SignedSource<<d282b8ab6f2ca4c383fb784468cd4b74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RemovedFromProjectV2Event$data = {
  readonly actor: {
    readonly " $fragmentSpreads": FragmentRefs<"EventActor">;
  } | null;
  readonly createdAt: string;
  readonly project: {
    readonly title: string;
    readonly url: string;
  } | null;
  readonly " $fragmentType": "RemovedFromProjectV2Event";
};
export type RemovedFromProjectV2Event$key = {
  readonly " $data"?: RemovedFromProjectV2Event$data;
  readonly " $fragmentSpreads": FragmentRefs<"RemovedFromProjectV2Event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RemovedFromProjectV2Event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EventActor"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectV2",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RemovedFromProjectV2Event",
  "abstractKey": null
};

(node as any).hash = "1fb434c83898ce7b6ee55f999d2bdd89";

export default node;
